import { useStorage } from '@hotjar/insights-common/hooks/useStorage';
import { getParams } from '@hotjar/webapp/domains/heatmaps/hooks/useHeatmapParams';
import { useCurrentSite } from '@hotjar/site';
import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

/**
 * Checks if the current heatmap parameters have been used before
 */
export const useHasSeenMultipleHeatmaps = (): boolean | undefined => {
  const { data: currentSite } = useCurrentSite();
  const [searchParams] = useSearchParams();
  const [seenParams, updateHeatmapSeenData] = useStorage<Array<string>>(
    'localStorage',
    `${currentSite?.id}_feedback_heatmaps_popup_seen_data`,
    [],
  );

  const hasSeenMultipleHeatmaps = useMemo(() => {
    if (currentSite === undefined) return undefined;

    const params = getParams(searchParams);

    if (seenParams.length > 1) {
      return true;
    }

    // only consider params with an url value to be a valid heatmap
    if (params.url === '') return false;

    const paramString = JSON.stringify(params);

    if (!seenParams.includes(paramString)) {
      updateHeatmapSeenData([...seenParams, paramString]);
      if (seenParams.length > 0) {
        return true;
      }
    }

    return false;
  }, [searchParams, seenParams, updateHeatmapSeenData, currentSite]);

  return hasSeenMultipleHeatmaps;
};
